import landingEn from "@locales/en/landing.json";
import notFoundEn from "@locales/en/not-found.json";
import toolsEn from "@locales/en/tools.json";
import finderAppEn from "@locales/en/finder-app.json";
import layoutsEn from "@locales/en/layouts.json";
import commonEn from "@locales/en/common.json";

export const resources = {
  en: {
    landing: landingEn,
    notFound: notFoundEn,
    tools: toolsEn,
    finderApp: finderAppEn,
    layouts: layoutsEn,
    common: commonEn
  }
};
